export default "__VITE_PUBLIC_ASSET__7b0e21bb__"